function SuccessDialog({ open, onClose, message }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-ink/50" onClick={onClose} />
      <div className="relative bg-canvas rounded-2xl p-6 w-full max-w-sm shadow-xl">
        <h3 className="font-display text-xl text-forest mb-2">Success</h3>
        <p className="text-ink/75 mb-6">{message}</p>
        <button
          onClick={onClose}
          className="bg-forest text-canvas font-medium px-5 py-2 rounded-full hover:bg-forest-dark transition-colors"
        >
          OK
        </button>
      </div>
    </div>
  );
}

export default SuccessDialog;